/*
 * -----------------------------------------------------------------------
 *  <copyright file="step4-overview.data.ts company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { Errors } from '@components/central-monitoring/panels/add-panel/interfaces';
import { SelectWithSearchDataArrayInterface } from '@components/core/select-with-categories/select-with-categories.interface';

export const STEP4_INITIAL_ERRORS: Errors = {
    yAxisColumnValue: '',
    label0: '',
    type0: '',
    dataSource0: '',
    dataField0: '',
    numeratorField0: '',
    denominatorField0: '',
    label1: '',
    type1: '',
    dataSource1: '',
    dataField1: '',
    numeratorField1: '',
    denominatorField1: '',
};

export const STEP4_NUMBER_OF_COLUMNS: SelectWithSearchDataArrayInterface[] = [
    { id: 0, text: '0' },
    { id: 1, text: '1' },
    { id: 2, text: '2' },
];

export const STEP4_COLUMN_INITIAL = {
    label: '',
    type: '',
    dataSource: null,
    dataField: '',
    numeratorField: '',
    denominatorField: '',
};
